module.exports = __webpack_public_path__ + "img/gamburger.35a48f84.jpeg";